const shop = {
  /**
   * 选择商城的label
   */
  filterText: '筛选条件',
  filterText_1: '筛选条件',
  /**
   * 选择商城的按钮
   */
  filterButton: '添加',
  /**
   * 选择商城的label
   */
  timeRange: '时间范围',
  button: {
    searchViaUpload: '上传查询商品',
    reset: '重置',
    submit: '提交',
    export: '导出',
  },
  tableTitle: '活动统计',
  table: {
    shopName: '商城名称',
    promoAmt: '活动信息数',
    promoBrandsAmt: '活动品牌数',
    detail: '详情',
    detailViewText: '查看',
  },
  tips: {
    noMall: '暂无商城',
  },
  modal: {
    queryShop: {
      title: '按商城查询',
    },
    brandInfo: {
      title: '品牌信息',
      skuTable: {
        image: '图片',
        code: 'Code',
        description: '描述',
        brand: '品牌',
      },
      table: {
        brand: '品牌',
        total: '总计',
        detail: '详情',
      },
    },
    shopInfo: {
      title: '商城信息',
      skuTable: {
        image: '图片',
        code: 'Code',
        description: '描述',
        brand: '品牌',
      },
      table: {
        brand: '商城名称',
        total: '总计',
        detail: '详情',
      },
    },
  },
};
const brand = {
  /**
   * 选择商城的label
   */
  filterText: '筛选条件',
  /**
   * 选择商城的按钮
   */
  filterButton: '添加',
  /**
   * 选择商城的label
   */
  timeRange: '时间范围',
  button: {
    searchViaUpload: '上传查询商品',
    reset: '重置',
    submit: '提交',
    export: '导出',
  },
  tableTitle: '活动统计',
  table: {
    brand: '品牌',
    shopName: '商城名称',
    promoAmt: '活动信息数',
    promoMallAmt: '活动商城数',
    detail: '详情',
    detailViewText: '查看',
  },
  modal: {
    selectBrandModal: {
      title: '选择品牌',
    },
  },
};

export default {
  shop,
  brand,
};
